import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { ScrollView, View, Text } from "react-native";
import { CheckBox } from "react-native-btr";
import { RadioButton } from "react-native-paper";

import EtherPlay from "@/assets/etherplay.svg";
import Subtitle from "@/components/Subtitle";
import SubtitleXl from "@/components/SubtitleXl";
import Title from "@/components/Title";
import Button from "@/components/button/Button";

interface SelectRailProps {
  sendData: (data: TransferType) => void;
}

type TransferType = "USD" | "WALLET";

export default function SelectRail(props: SelectRailProps) {
  const [option, setOption] = useState<TransferType>("USD");
  const { t } = useTranslation();

  const onSubmit = (data: TransferType) => {
    props.sendData(data);
  };

  return (
    <ScrollView contentContainerClassName="flex-grow items-center gap-4">
      <View className="w-full items-center gap-1">
        <Text className="text-2xl">{t("home/web3/selectrail:title")}</Text>
        <Text className="text-lg font-light">
          {t("home/web3/selectrail:subtitle")}
        </Text>
      </View>
      <EtherPlay height={180} />
      <View>
        <View className="flex-row gap-1 items-center">
          <RadioButton
            value="USD"
            status={option === "USD" ? "checked" : "unchecked"}
            onPress={() => setOption("USD")}
            color="#5D0CBA"
          />
          <Text className="text-lg text-black font-normal">
            {t("home/web3/selectrail:input.usdaccount")}
          </Text>
        </View>
        <View className="flex-row gap-1 items-center">
          <RadioButton
            value="WALLET"
            status={option === "WALLET" ? "checked" : "unchecked"}
            onPress={() => setOption("WALLET")}
            color="#5D0CBA"
          />
          <Text className="text-lg text-black font-normal">
            {t("home/web3/selectrail:input.anotherwallet")}
          </Text>
        </View>
      </View>

      <Button
        label={t("common:button.nextstep")}
        onClick={() => onSubmit(option)}
      />
    </ScrollView>
  );
}
